export const storage = {
  safeParseJson<T = any>(str: any, fallback: T = {} as T): T {
    try {
      return JSON.parse(str ?? 'null') ?? fallback;
    } catch {
      return fallback;
    }
  },

  get(key: string, fallback: string | null = null): string | null {
    try {
      const value = localStorage.getItem(key);
      return value === null ? fallback : value;
    } catch {
      return fallback;
    }
  },

  getJSON<T = any>(key: string, fallback: T = null as T): T {
    try {
      const value = localStorage.getItem(key);
      return value === null ? fallback : storage.safeParseJson(value, fallback);
    } catch {
      return fallback;
    }
  },

  set(key: string, value: any): boolean {
    try {
      localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
      return true;
    } catch {
      return false;
    }
  },

  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {}
  },

  safeClear(): void {
    const keepKeys = ['language', 'currency', 'optionalCountryId', 'invite_id'];
    for (const key of Object.keys(localStorage)) {
      if (!keepKeys.some(k => key.includes(k))) {
        storage.remove(key);
      }
    }
  },
};